import { get } from '../../../../service/ApiService';
import { axiosUserProfileInstance } from '../../../../configs/AxiosInstance';

// Read-only wrappers over the user-profile service's hormone tracker
// (`.md/HORMONE_TRACKER_README.md` §5). FlexBoard never calls the /modify
// endpoints: coaches can see a client's logs but not change them.

const BASE = '/hormone-tracker';

function query(params) {
  return Object.entries(params)
    .filter(([, v]) => v != null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
}

function fetchFrom(path, params) {
  return get(`${BASE}${path}?${query(params)}`, { instance: axiosUserProfileInstance });
}

/** Raw rows in [startDate, endDate] (inclusive; the server caps the range under 366 days). */
const rows = (path) => (userId, startDate, endDate) =>
  fetchFrom(path, { user_id: userId, start_date: startDate, end_date: endDate }).then(
    (res) => (Array.isArray(res?.data) ? res.data : [])
  );

/**
 * Summary as of `endDate` (always the browser's local day — the server's
 * default "today" is its own date, README gap 7).
 */
const summary = (path) => (userId, startDate, endDate) =>
  fetchFrom(`${path}/summary`, { user_id: userId, start_date: startDate, end_date: endDate });

export const fetchPeriodLogs = rows('/period');
export const fetchSymptomLogs = rows('/symptoms');
export const fetchEnergyLogs = rows('/energy');
export const fetchCravingLogs = rows('/cravings');

export const fetchPeriodSummary = summary('/period');
export const fetchSymptomSummary = summary('/symptoms');
export const fetchEnergySummary = summary('/energy');
export const fetchCravingSummary = summary('/cravings');
